import React from 'react';

export const CheckGray300Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.7514 3.92359L5.47924 11.1936C5.34701 11.3258 5.21479 11.3918 5.01646 11.3918C4.81813 11.3918 4.6859 11.3258 4.55368 11.1936L1.24814 7.88904C0.983694 7.62467 0.983694 7.22813 1.24814 6.96377C1.51258 6.6994 1.90925 6.6994 2.17369 6.96377L5.01646 9.80567L11.8259 2.99832C12.0903 2.73396 12.487 2.73396 12.7514 2.99832C13.0159 3.26268 13.0159 3.65923 12.7514 3.92359Z"
        fill="#DCDCDC"
      />
    </svg>
  );
};
